import { isEqual, get } from 'lodash'

type Join<K, P> = K extends string | number
  ? P extends string | number
    ? `${K}${'' extends P ? '' : '.'}${P}`
    : never
  : never

type ArrayKey<El> = El extends Record<string, unknown>
  ? {
      [K in keyof El]-?: El[K] extends Record<string, unknown>
        ? Join<K, keyof El[K]> | K
        : K
    }[keyof El]
  : never

export const unique = <El>(arr?: El[], paths?: ArrayKey<El>[]): El[] => {
  if (!Array.isArray(arr)) {
    throw new Error(`Expecting array, got ${typeof arr} instead`)
  }

  if (typeof arr[0] === 'object') {
    return arr.filter((el, index, self) => {
      const firstIndex: number = paths
        ? self.findIndex(d =>
            paths.every(path => isEqual(get(d, path), get(el, path)))
          )
        : self.findIndex(d => isEqual(d, el))

      return firstIndex === index
    })
  }

  return arr.filter((el, index, self) => self.indexOf(el) === index)
}

export const getFirstNonNull = <T>(arr: T[]) => arr.find(Boolean) as T

export const filterFalsy = <El>(arr: Array<El | null | undefined>): Array<El> =>
  arr.filter(Boolean) as El[]

export const contains = <El>(a: El[], b: El[]) => b.every(el => a.includes(el))
